import {studentDetailsActionTypes as types} from '../constants';

export function fetchStudentDetails(studentId, binderFilters) {
  return {type: types.FETCH_STUDENT_DETAILS, payload: {studentId, binderFilters}};
}

export function storeStudentDetails(studentId, details) {
  return {type: types.STORE_STUDENT_DETAILS, studentId, payload: details};
}
